import { cn } from "@omni/utils/styles";

import { BvTrustMark } from "@/components/Product/Reviews/bvTrustMark/bvTrustMark.container";
import { ProductReviews } from "@/components/Product/Reviews/productReviews/productReviews.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const Review = () => {
    const { t } = useGranite();

    return (
        <section id={t("productDetail.anchor.hash.reviews")}>
            <div className={cn("tw:flex tw:justify-baseline tw:items-center")}>
                <h4 className={cn("tw:mb-4 tw:font-bold")}>
                    {t("productDetail.anchor.title.reviews")}
                </h4>
                <BvTrustMark />
            </div>
            <ProductReviews />
        </section>
    );
};

export { Review };
